var React = require('react');

function Envelope (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m32 6.999019v13.0408c0 .5202-.0997 1.0352-.2937 1.5158-.194.4805-.4785.9172-.8371 1.2849-.3586.3678-.7843.6594-1.2528.8583-.4685.199-.9707.3012-1.4777.3010003h-24.27739c-.50706.0001997-1.00919-.1021003-1.47771-.3010003s-.89424-.4905-1.25283-.8583c-.358586-.3677-.643019-.8044-.837043-1.2849-.1940226-.4806-.293727-.9956-.293727-1.5158v-13.03977l16 10.99817zm-.9648-6.999019c.256.000289.5014.104794.6823.290557.1809.185764.2825.437592.2825.700162v1.94741l-16 10.99929-16-10.99827v-1.94843c0-.26258.101652-.514416.28257-.700181.180918-.185764.426324-.290262.682305-.290538z","fill":"currentColor"}));
}

Envelope.defaultProps = {"height":"24","viewBox":"0 0 32 24","width":"32"};

module.exports = Envelope;

Envelope.default = Envelope;
